import type { PageTypeResult } from 'src/hooks/usePageType'
import type { ProductItem } from 'src/components/restructure/product/types/productItem'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import { getProductQueryObject } from 'src/utils/amplitude/useProductObject'
import type { ProductQueryObject } from 'src/utils/amplitude/types/amplitudeObjects'

const ADD_TO_CART_SOURCE = 'add_together'

type TrackCrossSellV2PairParams = {
  mainSku: ProductItem
  crossSellSku: ProductItem
  pageData: PageTypeResult
  eventData?: Record<string, unknown>
}

function toProductDetail(
  sku: ProductItem,
  quantity: number
): ProductQueryObject | null {
  if (!sku.analytics?.amplitude) {
    return null
  }

  const price =
    sku.sellerDefault?.sellerOffer?.cashPrice ??
    sku.sellerDefault?.sellerOffer?.price ??
    0

  const detail = getProductQueryObject({
    ...sku.analytics.amplitude,
    quantity,
    purchase_price: price,
    purchase_value: price * quantity,
  })

  if (!detail || Object.keys(detail).length === 0) {
    return null
  }

  return detail
}

export function trackCrossSellV2PairAddedToCart({
  mainSku,
  crossSellSku,
  pageData,
  eventData,
}: TrackCrossSellV2PairParams) {
  const productDetails = [
    toProductDetail(mainSku, 1),
    toProductDetail(crossSellSku, 1),
  ].filter((detail): detail is ProductQueryObject => detail !== null)

  if (productDetails.length === 0) {
    return
  }

  dispatchAmplitudeEvent({
    eventName: 'Product Added To Cart',
    eventData: {
      ...getStandardObject(pageData),
      'product details': productDetails,
      'add location': pageData.currentPageType,
      'product viewed source': ADD_TO_CART_SOURCE,
      ...(eventData && { ...eventData }),
      'add to cart source': ADD_TO_CART_SOURCE,
    },
  })
}
